import { NgIf } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-aya-summary',
  templateUrl: './aya-summary.component.html',
  styleUrls: ['./aya-summary.component.scss', './print-aya-summary.component.scss'],
  imports: [NgIf],
})
export class AyaSummaryComponent implements OnChanges {
  @Input() language: string | undefined;
  @Input() year: string | number | undefined;

  protected programsShown = false;
  protected included: string | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['language'] || changes['year']) {
      this.initializeIncluded();
    }
  }

  private initializeIncluded() {
    this.programsShown = false;

    switch (this.language?.toLowerCase()) {
      case 'english':
        this.initializeEnglishIncluded();
        break;
      case 'french':
      case 'german':
        this.included =
          'Guaranteed morning classes, a dedicated orientation and graduation ceremony, free exam fees, monthly visits to iconic sites, and ongoing personalized support from academic advisors at school.';
        break;
      default:
        console.warn(`AyaSummaryComponent: Unsupported language '${this.language}', falling back to English.`);
        this.initializeEnglishIncluded();
        break;
    }
  }

  private initializeEnglishIncluded(): void {
    this.programsShown = true;

    // TODO
    // It's a hardcoded year for 2027. We need to think in something better in the future

    if (this.language?.toLowerCase() === 'english' && this.year?.toString() === '2027') {
      this.included =
        'Guaranteed morning classes, a dedicated orientation and graduation ceremony, free IELTS or TOEFL® exam fees, 12 months of access to K+ Learning Space post departure, monthly visits to iconic sites, Kaplan Guaranteed Progression aligned with the official CEFR, and ongoing personalized support from Kaplan academic advisors.';
    } else {
      this.included =
        'Guaranteed morning classes, a dedicated orientation and graduation ceremony, free IELTS or TOEFL® exam fees, 12 months of access to K+ Learning Space post departure, direct access to prestigious universities, campus visits, meet-and-greets with companies, monthly visits to iconic sites, Kaplan Guaranteed Progression aligned with the official CEFR, and ongoing personalized support from Kaplan academic advisors.';
    }
  }
}
